import { type ReactNode } from 'react';
import {
    Stepper as PrimeStepper,
    type StepperProps as PrimeStepperProps,
} from 'primereact/stepper';
import { StepperPanel as PrimeStepperPanel } from 'primereact/stepperpanel';
import './Stepper.scss';

export { type StepperChangeEvent } from 'primereact/stepper';
export const StepperPanel = PrimeStepperPanel;

export type StepperVariant = 'default' | 'pill';

export interface StepperProps extends Omit<PrimeStepperProps, 'className'> {
    variant?: StepperVariant;
    className?: string;
    children?: ReactNode;
}

export function Stepper({
    variant = 'default',
    className,
    ...props
}: StepperProps): ReactNode {
    const variantClass = variant === 'pill' ? 'ics-stepper-pill' : '';
    const combinedClassName = [variantClass, className]
        .filter(Boolean)
        .join(' ');

    return <PrimeStepper className={combinedClassName} {...props} />;
}
